export default {
    logos (state) {
      return state.logos
    },

    selectedLogo (state) {
        return state.selectedLogo
    },

    getLogo: state => (logoId) => {
      return state.logos().find(logo => logo.logoId === logoId)
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/logos/getters.js